(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schylling-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateCartCount = (count) => {
      if (!Number.isFinite(count)) return;

      document
        .querySelectorAll('.schylling-top-strip__count, .schylling-site-header__mobile-cart-count')
        .forEach((element) => {
          element.textContent = String(count);
        });
    };

    const syncCartCount = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) return;

        const cart = await response.json();
        updateCartCount(Number(cart.item_count));
      } catch (_error) {
        // Keep the server-rendered count when the cart endpoint is unavailable.
      }
    };

    if (!window.schyllingCartCountBound) {
      window.schyllingCartCountBound = true;

      document.addEventListener('cart:update', (event) => {
        const resourceCount = Number(event.detail?.resource?.item_count);
        if (Number.isFinite(resourceCount)) {
          updateCartCount(resourceCount);
          return;
        }

        syncCartCount();
      });

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) syncCartCount();
      });
    }

    document.querySelectorAll('.schylling-site-header').forEach((section) => {
      const toggle = section.querySelector('[data-drawer-toggle]');
      const close = section.querySelector('[data-drawer-close]');
      const drawer = section.querySelector('.schylling-site-header__drawer');

      if (!toggle || !drawer || section.dataset.drawerBound === 'true') return;
      section.dataset.drawerBound = 'true';

      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          drawer.hidden = false;
          section.dataset.drawerOpen = 'true';
        } else {
          drawer.hidden = true;
          section.dataset.drawerOpen = 'false';
        }
      };

      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      if (close) {
        close.addEventListener('click', () => setOpen(false));
      }

      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
